import React, { useEffect } from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css";

function UiUxDesign() {
   useEffect(()=>{
     AOS.init({duration:1000, once:true});
   },[])
  return (
    <div className="webdev-page" style={{overflowX:"hidden"}}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="inner-banner-content">
              <h1 className="inner-title">UI/UX Design </h1>
            </div>
          </div>
        </div>
      </section>

     
      <section className="testing-intro-section">
                <div className="container">
                <div className="section-header">
                        <h2 data-aos="fade-up">Crafting Exceptional User Experiences</h2>
                        <p className="section-description">
                        We design user experiences that are intuitive, visually engaging, and deeply aligned with your audience’s needs. Our approach is rooted in user research, behavioral insights, and a strong focus on usability. By collaborating closely with clients, our design team ensures every interface reflects your brand identity and resonates with your target audience, resulting in solutions that engage users and drive measurable results.            </p>
                    </div>
                </div>
                </section>

      {/* Our Services Section */}
      <section className="webdev-services-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Design Services</h2>
            <p className="section-description">
              Comprehensive design solutions tailored to your specific needs and business goals
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-mobile-alt"></i>
              </div>
              <h3>Mobile App Design</h3>
              <p>Design sleek, visually appealing mobile applications that prioritize seamless navigation, intuitive flows, and impactful messaging to enhance user engagement.
</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-desktop"></i>
              </div>
              <h3>Website Design</h3>
              <p>Develop websites with a clear structure, easy navigation, and brand-aligned visuals that make exploring your content effortless and enjoyable.
</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-cubes"></i>
              </div>
              <h3>Product Design</h3>
              <p>Deliver complete product design solutions, from early concepts and wireframes to fully polished digital experiences that provide value to both users and businesses.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Design Process Section */}
      <section className="design-process-section">
        <div className="container">
          <div className="section-header">
            <h2>Our UI/UX Design Process</h2>
            <p className="section-description">
              A structured approach that ensures we deliver exceptional user experiences tailored to your business goals
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "User Research & Analysis",
                text: "Conduct research to understand your audience’s needs, behaviors, and challenges through surveys, interviews, and data analysis.",
              },
              {
                num: 2,
                title: "Information Architecture",
                text: "Organize information into intuitive structures with sitemaps and user flows that simplify navigation."
              },
              {
                num: 3,
                title: "Wireframing",
                text: "Create wireframes to outline content placement and functionality without visual clutter."
              },
              {
                num: 4,
                title: "Prototyping",
                text: "Develop interactive prototypes to test and validate user interactions before development."
              },
              {
                num: 5,
                title: "Visual Design",
                text: "Apply brand-focused visuals, typography, color schemes, and accessible design elements to create polished interfaces."
              },
              {
                num: 6,
                title: "Usability Testing",
                text: "Test usability with real users to identify friction points and refine the design for better experiences."
              },
              {
                num: 7,
                title: "Implementation Support",
                text: "Support developers with detailed style guides, assets, and close collaboration to ensure flawless implementation."
              },
              {
                num: 8,
                title: "Iterative Improvement",
                text: "Continuously improve the product post-launch by collecting feedback and iterating for long-term success."
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-left" data-aos-delay="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Design Principles Section */}
      <section className="design-principles-section">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our Designs</h2>
            <p className="section-description">
              Our design philosophy is built on principles that ensure exceptional user experiences
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="300">
            {[
              {
                icon: "fas fa-users",
                title: "User-Centered Design",
                text: "Every feature and visual decision is informed by user needs and goals."
              },
              {
                icon: "fas fa-fingerprint",
                title: "Consistent Branding",
                text: "Unified visual elements reinforce brand recognition and trust."
              },
              {
                icon: "fas fa-universal-access",
                title: "Accessibility Compliance",
                text: "Designs meet WCAG standards to ensure inclusivity."
              },
              {
                icon: "fas fa-tablet-alt",
                title: "Responsive Design",
                text: "Seamless experiences across desktop, tablet, and mobile screens."
              },
              {
                icon: "fas fa-magic",
                title: "Microinteractions",
                text: "Subtle animations and feedback elements enhance usability and engagement."
              },
              {
                icon: "fas fa-chart-line",
                title: "Data-Driven Decisions",
                text: "Decisions are guided by analytics, A/B testing, and real user feedback."
              }
            ].map((feature, idx) => (
              <div className="service-card" key={idx} >
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section mt-5">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your User Experience?</h2>
            <p>Let's create intuitive, engaging designs that delight your users and drive business results.</p>
            <a href="/contact" className="cta-button">Get a Free Design Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default UiUxDesign;
